import React from "react";
import { View } from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { s } from "../SustainTeamManagementScreen.styles";
import { TeamMember } from "./SustainTeamTypes";
import { useTheme } from "../../../theme";

interface Props {
  channels: TeamMember["channelsOnDuty"];
  isDark?: boolean;
}

const ChannelIcons: React.FC<Props> = ({ channels, isDark }) => {
  const { colors } = useTheme();
  const boxStyle = (active: boolean) => [
    s.channelIcon,
    active && s.channelActive,
    isDark && {
      backgroundColor: active ? colors.statusBackground.info : colors.background.elevated,
    },
  ];
  const iconColor = (active: boolean) =>
    isDark
      ? active ? colors.brand.primary : colors.text.disabled
      : active ? "#034895" : "#C0C0C0";
  return (
    <View style={s.channelRow}>
      <View style={boxStyle(!!channels.nav)}>
        <MaterialIcons name="dashboard"           size={13} color={iconColor(!!channels.nav)} />
      </View>
      <View style={boxStyle(!!channels.email)}>
        <MaterialIcons name="email"               size={13} color={iconColor(!!channels.email)} />
      </View>
      <View style={boxStyle(!!channels.teams)}>
        <MaterialIcons name="chat-bubble-outline" size={13} color={iconColor(!!channels.teams)} />
      </View>
    </View>
  );
};

export default ChannelIcons;
